import { RouterProvider } from 'react-router-dom'
import { useRecoilValue } from 'recoil'
import { useEffect } from 'react'

import { isLoggedIn } from 'services/auth'
import { actionBrowser } from './routes/routes'

import './app.style.css'
import './sanitize.css'

const App = () => {
  const [logged] = useRecoilValue(isLoggedIn)

  useEffect(() => {
    if (!logged && !window.location.href.includes('login')) {
      window.location.href = '/login'
    }
  }, [logged])

  return <RouterProvider router={actionBrowser} />
}

export default App
